import { GraphQLWSLink, KEEP_ALIVE } from './GraphQLWSLink.ts';

// code borrowed from WebSocketLink.ts but modified to hit subscriptions
export function getWebSocketURL(): string {
	let WEBSOCKET_URL: string;

	if (process.env.PILLAR_LOCAL_DEVELOPMENT === 'true') {
		const wsProtocol = window?.location?.protocol === 'https:' ? 'wss' : 'ws';
		WEBSOCKET_URL = `${wsProtocol}://${window?.location?.host}/gateway/api/graphql/subscriptions`;
	} else if (process.env.NODE_ENV !== 'production') {
		// In dev mode this allows the local dev proxy to use the WebSocket host
		// that matches the backend origin host. The __backendOriginHost is only
		// available with local dev server.
		const host = (window as any)?.__backendOriginHost || window?.location?.host;

		WEBSOCKET_URL = `wss://${host}/gateway/api/graphql/subscriptions`;
	} else {
		WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
	}

	return WEBSOCKET_URL;
}

let wsLink: GraphQLWSLink | undefined;

export function getAGGWebSocketLinkInstance(): GraphQLWSLink {
	const WEBSOCKET_URL = getWebSocketURL();
	if (!wsLink) {
		wsLink = new GraphQLWSLink({
			url: () => {
				return WEBSOCKET_URL;
			},
			shouldRetry: () => {
				return true;
			},
			keepAlive: KEEP_ALIVE, // ping server every 10 min
			retryAttempts: 5,
		});
	}

	return wsLink;
}
